import React from 'react'
import cx from 'classnames'
import menuIcon from 'theme/icons/menu.svg'
import closeIcon from 'theme/icons/close.svg'
import Button from 'components/atoms/Button/Button'
import styles from 'components/organisms/MobileMenuBar/MobileMenuBar.module.scss'

interface IMobileMenuBarProps {
  className?: string
  agencyName: string
  agencyLogo?: string
  onToggle: () => void
  isOpen: boolean
}

const MobileMenuBar = ({ className, agencyName, agencyLogo, onToggle, isOpen }: IMobileMenuBarProps) => {
  const classes = cx([styles.root, className])
  return (
    <div className={classes}>
      <div className={styles.brand}>
        {agencyLogo && <img src={agencyLogo} alt={agencyName} />}
        <h3>{agencyName}</h3>
      </div>
      <Button className={styles['menu-button']} size="sm" link onClick={onToggle}>
        <img src={isOpen ? closeIcon : menuIcon} alt={isOpen ? 'close menu' : 'open menu'} />
      </Button>
    </div>
  )
}

export default MobileMenuBar
